import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'

async function getBusquedas (params) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      resolve(mock.getNotification)
    })
  } else {
    const req = {
      url: '/api/usuarios/getbusquedas',
      method: 'GET',
      params
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { getBusquedas }
